import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import likeBadgeImg from 'assets/images/heart-badge.png'
import { CUSTOMER_REVIEWS } from 'modules/purchase/constants'
import { StyledCustomerReviewsListV2 as S } from './CustomerReviewsListV2.styles'

export const CustomerReviewsListV2: React.FC = () => {
  const { t } = useTranslation()

  return (
    <S.Wrapper>
      <S.Title>
        <S.TitleText>
          <Trans
            i18nKey="purchase.customerReviews.title"
            components={[<strong />, <br />]}
          />
        </S.TitleText>
        <S.Img src={likeBadgeImg} alt="Like" width="104px" />
      </S.Title>
      {CUSTOMER_REVIEWS.map(({ id, author, text, icon }) => (
        <S.Review key={id} author={author} text={t(text as any)} icon={icon} />
      ))}
    </S.Wrapper>
  )
}
